import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkflowTransitionPrivilegeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkflowTransitionPrivilegeModel._instance == null) WorkflowTransitionPrivilegeModel._instance = new WorkflowTransitionPrivilegeModel(authManager);
        return WorkflowTransitionPrivilegeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/workflow-transition-privileges');

        this.entityName = 'core.WorkflowTransitionPrivilege';
        this.privileges = {
            create: [["adminWorkflow"]],
            read: [["#everyone"]],
            update: [["adminWorkflow"]],
            delete: [["adminWorkflow"]],
        };

        this.label = 'Workflow Transition Privilege';
        this.setLabel = 'Workflow Transition Privileges';

        this.browser = {
            name: 'default-core-workflowtransitionprivilege-browser',
            moduleName: 'default-core-workflowtransitionprivilege-browser',
            moduleTitle: 'Workflow Transition Privileges',
            moduleStateSlotName: 'default-core-workflowtransitionprivilege-browser',
        };

        this.editor = {
            name: 'default-core-workflowtransitionprivilege-editor',
            moduleName: 'default-core-workflowtransitionprivilege-editor',
            moduleTitle: 'Workflow Transition Privilege',
            moduleStateSlotName: 'default-core-workflowtransitionprivilege-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'workflowId',
                type: 'Workflow',
                persistent: true,
                label: 'Workflow',
            },
            {
                name: 'transitionId',
                type: 'WorkflowTransition',
                persistent: true,
                label: 'Workflow Transition',
            },
            {
                name: 'userId',
                type: 'User',
                persistent: true,
                label: 'User',
            },
            {
                name: 'roleId',
                type: 'Role',
                persistent: true,
                label: 'Role',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
